import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js';

export default class AddToCart extends HTMLDivElement {

    constructor() {
        super();
        this.addToCartButton = this.querySelector('add-to-cart-qty');
        this.qtySelector = this.querySelector('quantity-selector');
    }

    connectedCallback() {
        // Événements
        this.initEvents();
    }

    /**
     * Événements.
     */
    initEvents() {
        // Ici on ne se base pas sur l'évènement click du bouton d'ajout au panier mais sur la présence du cartLineId
        // une fois le produit ajouté au panier
        const observer = new MutationObserver((mutations, obs) => {
            for (const m of mutations) {
                // 1) un bouton vient d'être ajouté ?
                if (m.type === 'childList') {
                    for (const node of m.addedNodes) {
                        if (node.nodeType === 1 && node.tagName === 'ADD-TO-CART-QTY') {
                            this.addToCartButton = node;
                        }
                    }
                }
                // 2) un data-cart-line-id apparaît sur un bouton (nouveau ou existant) ?
                if (
                    m.type === 'attributes' &&
                    m.attributeName === 'data-cart-line-id' &&
                    m.target.tagName === 'ADD-TO-CART-QTY'
                ) {
                    const btn = m.target;
                    const { cartLineId, qtyHref, productId } = btn.dataset;
                    if (cartLineId) {
                        const quantity = this.qtySelector ? this.qtySelector.value : 1; // ou une autre valeur par défaut

                        new Requestor().sendRequest(qtyHref, 'POST', { productId, cartLineId, quantity }, data => {
                            this.showQtySelector(data, btn);
                        });
                        return;
                    }
                }
            }
        });

        // on observe le composant entier : ajout de nœuds + changements d'attribut
        observer.observe(this, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['data-cart-line-id'],
        });
    }

    showQtySelector(data, btn) {
        if(!this.querySelector('quantity-selector')) {
            // On remplace le bouton par le sélecteur de quantité
            const tempDiv = document.createElement('quantity-selector');
            tempDiv.innerHTML = data.template;
            btn.replaceWith(tempDiv.firstElementChild);
        }
    }
}
